export async function fetchSucursales({ idcompany, usuarioId }) {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/sucursales?idcompany=${idcompany}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Usuario-ID': usuarioId,
            ...(idcompany ? { 'X-company-ID': idcompany } : {})
          }
        }
      );
  
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Error al cargar sucursales');
      }
  
      const data = await response.json();
      console.log(data)
      return data; // lista de sucursales
    } catch (error) {
      throw error;
    }
  }
  

  export async function fetchUsuarios({ usuarioId, idcompany }) {
    let url = `${process.env.REACT_APP_SERVER_URL}/api/usuarios`;
    if (idcompany) url += `?idcompany=${idcompany}`;
  
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': usuarioId,
          ...(idcompany ? { 'X-company-ID': idcompany } : {})
        }
      });
  
      if (!response.ok) {
        const error = await response.json();
        console.log(error)
        throw new Error(error.error || 'Error al cargar usuarios');
      }
  
      return await response.json();
    } catch (error) {
      console.log(error)
      throw error;
    }
  }
  
  export async function fetchAlmacenes({ usuarioId, idcompany }) {
    let url = `${process.env.REACT_APP_SERVER_URL}/api/almacenes`;
    if (idcompany) url += `?idcompany=${idcompany}`;
  
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': usuarioId,
          ...(idcompany ? { 'X-company-ID': idcompany } : {})
        }
      });
  
      if (!response.ok) {
        const error = await response.json();
        console.log(error)
        throw new Error(error.error || 'Error al cargar usuarios');
      }
  
      return await response.json();
    } catch (error) {
      console.log(error)
      throw error;
    }
  }

export async function fetchCategorias({ usuarioId, idcompany }) {
  let url = `${process.env.REACT_APP_SERVER_URL}/api/categorias/${idcompany}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': usuarioId,
        ...(idcompany ? { 'X-company-ID': idcompany } : {})
      }
    });

    if (!response.ok) {
      const error = await response.json();
      console.log(error)
      throw new Error(error.error || 'Error al cargar categorías');
    }

    return await response.json();
  } catch (error) {
    console.log(error)
    throw error;
  }
}


export async function fetchProductos({ usuarioId, idcompany, idcategoria }) {
  let url = `${process.env.REACT_APP_SERVER_URL}/api/productos/${idcompany}/${idcategoria}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': usuarioId,
        ...(idcompany ? { 'X-company-ID': idcompany } : {})
      }
    });

    if (!response.ok) {
      const error = await response.json();
      console.log(error)
      throw new Error(error.error || 'Error al cargar productos');
    }

    return await response.json();
  } catch (error) {
    console.log(error)
    throw error;
  }
}

export async function fetchProductosPorCategoria({ usuarioId, idcompany, tipocategoria }) {
  let url = `${process.env.REACT_APP_SERVER_URL}/api/productos/${idcompany}?tipocategoria=${tipocategoria}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': usuarioId,
        ...(idcompany ? { 'X-company-ID': idcompany } : {})
      }
    });

    if (!response.ok) {
      const error = await response.json();
      console.log(error)
      throw new Error(error.error || 'Error al cargar productos');
    }

    return await response.json();
  } catch (error) {
    console.log(error)
    throw error;
  }
}

export async function fetchListasDePrecios({ usuarioId, idcompany }) {
  let url = `${process.env.REACT_APP_SERVER_URL}/api/listaprecios/${idcompany}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': usuarioId,
        ...(idcompany ? { 'X-company-ID': idcompany } : {})
      }
    });

    if (!response.ok) {
      const error = await response.json();
      console.log(error)
      throw new Error(error.error || 'Error al cargar listas de precios');
    }

    return await response.json();
  } catch (error) {
    console.log(error)
    throw error;
  }
}

export async function fetchProveedores({ usuarioId, idcompany }) {
  let url = `${process.env.REACT_APP_SERVER_URL}/api/proveedores?idcompany=${idcompany}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': usuarioId,
        ...(idcompany ? { 'X-company-ID': idcompany } : {})
      }
    });

    if (!response.ok) {
      const error = await response.json();
      console.log(error)
      throw new Error(error.error || 'Error al cargar proveedores');
    }

    return await response.json();
  } catch (error) {
    console.log(error)
    throw error;
  }
}

export async function fetchBancos({ usuarioId, idcompany }) {
  let url = `${process.env.REACT_APP_SERVER_URL}/api/bancos`;
  if (idcompany) url += `?idcompany=${idcompany}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': usuarioId,
        ...(idcompany ? { 'X-company-ID': idcompany } : {})
      }
    });

    if (!response.ok) {
      const error = await response.json();
      console.log(error)
      throw new Error(error.error || 'Error al cargar bancos');
    }

    return await response.json();
  } catch (error) {
    console.log(error)
    throw error;
  }
}

export async function fetchMonedas({ usuarioId, idcompany }) {
  let url = `${process.env.REACT_APP_SERVER_URL}/api/monedas`;
  if (idcompany) url += `?idcompany=${idcompany}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': usuarioId,
        ...(idcompany ? { 'X-company-ID': idcompany } : {})
      }
    });

    if (!response.ok) {
      const error = await response.json();
      console.log(error)
      throw new Error(error.error || 'Error al cargar monedas');
    }

    return await response.json();
  } catch (error) {
    console.log(error)
    throw error;
  }
}

export async function fetchProductosFinancieros({ usuarioId, idcompany }) {
  let url = `${process.env.REACT_APP_SERVER_URL}/api/prodfinancieros/${idcompany}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': usuarioId,
        ...(idcompany ? { 'X-company-ID': idcompany } : {})
      }
    });

    if (!response.ok) {
      const error = await response.json();
      console.log(error)
      throw new Error(error.error || 'Error al cargar productos financieros');
    }

    return await response.json();
  } catch (error) {
    console.log(error)
    throw error;
  }
}

export async function fetchClientes({ usuarioId, idcompany }) {
  let url = `${process.env.REACT_APP_SERVER_URL}/api/clientes/${idcompany}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': usuarioId,
        ...(idcompany ? { 'X-company-ID': idcompany } : {})
      }
    });

    if (!response.ok) {
      const error = await response.json();
      console.log(error)
      throw new Error(error.error || 'Error al cargar clientes');
    }

    return await response.json();
  } catch (error) {
    console.log(error)
    throw error;
  }
}


export async function fetchPortafolios({ usuarioId, idcompany }) {
  let url = `${process.env.REACT_APP_SERVER_URL}/api/portafolios/${idcompany}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': usuarioId,
        ...(idcompany ? { 'X-company-ID': idcompany } : {})
      }
    });

    if (!response.ok) {
      const error = await response.json();
      console.log(error)
      throw new Error(error.error || 'Error al cargar portafolios');
    }

    return await response.json();
  } catch (error) {
    console.log(error)
    throw error;
  }
}

export async function postAbonoCapital({ idcompany, usuarioId, payload }) {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/api/pagos-prestamo/abono-capital`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': usuarioId,
        ...(idcompany ? { 'X-company-ID': idcompany } : {})
      },
      body: JSON.stringify({ ...payload, idcompany })
    }
  );
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new Error(data.message || 'Error al aplicar abono a capital');
  }
  return data;
}

// ============================================================================
// Cargos asignados a un prestamo (saldo + abonos parciales)
// ============================================================================

function _commonHeaders({ usuarioId, idcompany }) {
  return {
    'Content-Type': 'application/json',
    'X-Usuario-ID': usuarioId,
    ...(idcompany ? { 'X-company-ID': idcompany } : {}),
  };
}

export async function fetchCargosAsignados({ idPrestamo, idcompany, usuarioId }) {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/api/prestamos/${idPrestamo}/cargos_asignados`,
    { method: 'GET', headers: _commonHeaders({ usuarioId, idcompany }) }
  );
  const data = await response.json().catch(() => []);
  if (!response.ok) throw new Error(data.error || 'Error al cargar cargos asignados');
  return Array.isArray(data) ? data : [];
}

export async function asignarCargoPrestamo({ idPrestamo, idcompany, usuarioId, payload }) {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/api/prestamos/${idPrestamo}/cargos_asignados`,
    {
      method: 'POST',
      headers: _commonHeaders({ usuarioId, idcompany }),
      body: JSON.stringify(payload),
    }
  );
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || 'Error al asignar el cargo');
  return data;
}

export async function eliminarCargoAsignado({ id, idcompany, usuarioId }) {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/api/cargos_asignados/${id}`,
    { method: 'DELETE', headers: _commonHeaders({ usuarioId, idcompany }) }
  );
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || 'Error al eliminar el cargo');
  return data;
}

export async function previewDistribucionPago({ idPrestamo, idcompany, usuarioId, monto, cuotas }) {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/api/prestamos/${idPrestamo}/preview_pago`,
    {
      method: 'POST',
      headers: _commonHeaders({ usuarioId, idcompany }),
      body: JSON.stringify({ monto, cuotas }),
    }
  );
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || 'Error al calcular desglose');
  return data;
}

export async function cancelAbonoCapital({ idcompany, usuarioId, pagoId, payload }) {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/api/pagos-prestamo/abono-capital/${pagoId}/cancelar`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': usuarioId,
        ...(idcompany ? { 'X-company-ID': idcompany } : {})
      },
      body: JSON.stringify({ ...(payload || {}), idcompany })
    }
  );
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new Error(data.message || 'Error al cancelar el abono a capital');
  }
  return data;
}